import React, { useState, useEffect } from 'react';
import { useHierarchicalMenu } from 'react-instantsearch';
import './GroupedCategoryMenu.css';

const categoryGroups = {
  'Ropa superior': [
    'abrigos', 'blazers', 'bodys', 'camisas', 'camisetas', 'cardigans',
    'chalecos', 'chaquetas', 'jerseys', 'sudaderas', 'tops',
  ].sort(),
  'Ropa inferior': ['bañadores', 'faldas', 'leggings', 'pantalones', 'vaqueros'].sort(),
  'Ropa cuerpo completo': ['chandals', 'monos', 'pijamas', 'trajes', 'vestidos'].sort(),
  'Calzado': ['calcetines', 'chanclas', 'zapatos', 'zapatillas'].sort(),
  'Complementos': [
    'bisutería', 'carteras', 'cinturones', 'corbatas', 'gafas', 'gorras',
    'guantes', 'lencería', 'mochilas', 'relojes', 'riñoneras', 'sombreros',
  ].sort(),
};

export const GroupedCategoryMenu = () => {
  const { items, refine } = useHierarchicalMenu({
    attributes: [
      'hierarchicalCategories.lvl0',
      'hierarchicalCategories.lvl1',
      'hierarchicalCategories.lvl2',
    ],
    limit: 50,
    showMore: true,
    showMoreLimit: 100,
  });

  const [groupedItems, setGroupedItems] = useState({});
  const [expandedGroups, setExpandedGroups] = useState({});

  useEffect(() => {
    if (!items || items.length === 0) return;

    const newGroupedItems = {};
    const categoryMap = {};

    const flattenItems = (nodes) => {
      nodes.forEach((node) => {
        categoryMap[node.label.toLowerCase()] = node;
        if (node.data) flattenItems(node.data);
      });
    };

    flattenItems(items);

    Object.entries(categoryGroups).forEach(([group, cats]) => {
      newGroupedItems[group] = cats
        .map((cat) => categoryMap[cat.toLowerCase()])
        .filter(Boolean)
        .map((node) => ({ ...node, isGrouped: true }));
    });

    setGroupedItems(newGroupedItems);
  }, [items]);

  const toggleGroupExpand = (group) => {
    setExpandedGroups((prev) => {
      const isCurrentlyExpanded = !!prev[group];
      return isCurrentlyExpanded ? {} : { [group]: true };
    });
  };

  const handleRefine = (item) => {
    refine(item.value);
  };

  if (!Object.keys(groupedItems).length) return null;

  return (
    <div className="grouped-hierarchical-menu">
      {Object.entries(groupedItems).map(([groupName, groupItems]) => {
        const isGroupActive = groupItems.some(
          (item) => item.isRefined || (item.data && item.data.some((sub) => sub.isRefined))
        );

        return (
          <div key={groupName} className="category-group">
            <button
              className={`group-button ${isGroupActive ? 'is-selected' : ''}`}
              onClick={() => toggleGroupExpand(groupName)}
            >
              {groupName}
            </button>

            {expandedGroups[groupName] && (
              <div className="group-categories">
                {groupItems.map((item) => (
                  <div key={item.value} className="hierarchical-group">
                    <div className={`hierarchical-item ${item.data ? 'with-children' : ''}`}>
                      <input
                        type="checkbox"
                        checked={item.isRefined}
                        onChange={() => handleRefine(item)}
                        id={`check-${item.value}`}
                      />
                      <label
                        htmlFor={`check-${item.value}`}
                        className={`category-label ${item.isRefined ? 'is-selected' : ''}`}
                      >
                        <span className="label-text">{item.label}</span>
                        <span className="count">{item.count}</span>
                      </label>
                    </div>

                    {item.isRefined && item.data && (
                      <div className="subitems-container">
                        {item.data.map((subItem) => (
                          <div
                            key={subItem.value}
                            className={`hierarchical-item level-1 ${subItem.data ? 'with-children' : ''}`}
                          >
                            <input
                              type="checkbox"
                              checked={subItem.isRefined}
                              onChange={() => handleRefine(subItem)}
                              id={`check-${subItem.value}`}
                            />
                            <label
                              htmlFor={`check-${subItem.value}`}
                              className={`category-label ${subItem.isRefined ? 'is-selected' : ''}`}
                            >
                              <span>{subItem.label.split('>').pop().trim()}</span>
                              <span className="count">{subItem.count}</span>
                            </label>

                            {subItem.isRefined && subItem.data && (
                              <div className="subcategory-level">
                                {subItem.data.map((thirdItem) => (
                                  <div key={thirdItem.value} className="hierarchical-item level-2">
                                    <input
                                      type="checkbox"
                                      checked={thirdItem.isRefined}
                                      onChange={() => handleRefine(thirdItem)}
                                      id={`check-${thirdItem.value}`}
                                    />
                                    <label
                                      htmlFor={`check-${thirdItem.value}`}
                                      className={`category-label ${thirdItem.isRefined ? 'is-selected' : ''}`}
                                    >
                                      <span>{thirdItem.label.split('>').pop().trim()}</span>
                                      <span className="count">{thirdItem.count}</span>
                                    </label>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
